import createIcon from '../../createIcon';

/**
 * @component @name Fireplace
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAyVjIySDIyVjJIMlpNMTEuODYgMTYuOTZDMTIuNjIgMTYuNzIgMTMuMjYgMTUuOTIgMTMuMzkgMTUuMzNDMTMuNTIgMTQuNzcgMTMuMjkgMTQuMjggMTMuMTkgMTMuNzNDMTMuMTEgMTMuMjcgMTMuMTIgMTIuODggMTMuMjcgMTIuNDVDMTMuODEgMTMuNjYgMTUuNDIgMTQuMDkgMTUuMjUgMTUuNjNDMTUuMDYgMTcuMzMgMTMuMTQgMTguMDEgMTEuODYgMTYuOTZaTTIwIDIwSDE4VjE4SDE1Ljk4QzE2LjYxIDE3LjE2IDE3IDE2LjEzIDE3IDE1QzE3IDEzLjExIDE1LjkxIDEyLjE1IDE1LjE1IDExLjYzQzEyLjIgOS42MSAxMyA3IDEzIDdDNi4yNyAxMC41NyA2Ljk4IDE0LjQ3IDcgMTVDNy4wMyAxNS45NiA3LjQ5IDE3LjA3IDguMjMgMThINlYyMEg0VjRIMjBWMjBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Fireplace = createIcon('Fireplace', [
  [
    'path',
    {
      d: 'M2 2V22H22V2H2ZM11.86 16.96C12.62 16.72 13.26 15.92 13.39 15.33C13.52 14.77 13.29 14.28 13.19 13.73C13.11 13.27 13.12 12.88 13.27 12.45C13.81 13.66 15.42 14.09 15.25 15.63C15.06 17.33 13.14 18.01 11.86 16.96ZM20 20H18V18H15.98C16.61 17.16 17 16.13 17 15C17 13.11 15.91 12.15 15.15 11.63C12.2 9.61 13 7 13 7C6.27 10.57 6.98 14.47 7 15C7.03 15.96 7.49 17.07 8.23 18H6V20H4V4H20V20Z',
      key: 'ok79qn',
    },
  ],
]);

export default Fireplace;
